import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import Swal from "sweetalert2";
import { axiosClient } from "../AxiosClient";
import { OFFER_STATUS_LABELS, formatDate, formatMoney } from "./condonationFormat";

export default function OfertasListDialog({ open, activeQuota, onClose }) {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchOffers = () => {
    if (!activeQuota) {
      return;
    }
    setLoading(true);
    axiosClient
      .get(`/v1/condonations/quotas/${activeQuota.quota.uuid}/offers`)
      .then((response) => {
        setLoading(false);
        setOffers(response.data || []);
      })
      .catch((error) => {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: "No se pudieron cargar las ofertas",
          text: error.response?.data?.message || "Intenta de nuevo.",
          confirmButtonColor: "#161e55",
        });
      });
  };

  useEffect(() => {
    if (open) {
      fetchOffers();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, activeQuota]);

  if (!activeQuota) {
    return null;
  }

  const handleCancel = (offer) => {
    axiosClient
      .post(`/v1/condonations/offers/${offer.uuid}/cancel`)
      .then(() => {
        fetchOffers();
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "No se pudo cancelar la oferta",
          text: error.response?.data?.message || "Intenta de nuevo.",
          confirmButtonColor: "#161e55",
        });
      });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{`Ofertas de la cuota #${activeQuota.quota?.quotaNumber ?? ""}`}</DialogTitle>
      <DialogContent>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Vencimiento</TableCell>
                <TableCell>Estado</TableCell>
                <TableCell>Total condonado</TableCell>
                <TableCell>El cliente pagará</TableCell>
                <TableCell>Motivo</TableCell>
                <TableCell>Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {offers.length === 0 && !loading && (
                <TableRow>
                  <TableCell colSpan={6}>
                    <Typography variant="body2">No hay ofertas registradas.</Typography>
                  </TableCell>
                </TableRow>
              )}
              {offers.map((offer) => (
                <TableRow key={offer.uuid}>
                  <TableCell>{formatDate(offer.expirationDate)}</TableCell>
                  <TableCell>{OFFER_STATUS_LABELS[offer.status] || offer.status}</TableCell>
                  <TableCell>{formatMoney(offer.totalCondoned)}</TableCell>
                  <TableCell>
                    {offer.amountToPay != null ? formatMoney(offer.amountToPay) : "—"}
                  </TableCell>
                  <TableCell>{offer.reason}</TableCell>
                  <TableCell>
                    {offer.status === "PENDING_OFFER" && (
                      <Button color="error" onClick={() => handleCancel(offer)}>
                        Cancelar
                      </Button>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
}
